import { undeadUnits } from "./undeadUnits";
import { kingdomUnits } from "./kingdomUnits";
import { wildUnits } from "./wildUnits";
import { hordeUnits } from "./hordeUnits";
import { otherworldUnits } from "./otherworldUnits";
import { underearthUnits } from "./underearthUnits";

const armyData = [
  kingdomUnits,
  wildUnits,
  undeadUnits,
  hordeUnits,
  otherworldUnits,
  underearthUnits,
];

export { armyData };
